<div class="row" style="margin-top: 10px;">
  <div class="col-lg-4">
    <div class="form-group has-float-label">
      <select class="form-control" [(ngModel)]="resource.RESOURCE_ID" (ngModelChange)="selectItem($event)">
        <option>SELECT</option>
        @for (item of listResourceSow; track item) {
          <option value="{{item.RESOURCE_ID}}">{{item.USERNAME}}</option>
        }
      </select>
      <label for="">Resource name *</label>
    </div>
  </div>
  <div class="col-lg-4">
    <div class="form-group has-float-label">
      <input [(ngModel)]="resource.RESOURCE_ID" class="form-control" id="" type="text"
        placeholder="Resource ID" disabled=""/>
        <label for="">Resource ID</label>
      </div>
    </div>
    <div class="col-lg-4">
    </div>
    <div class="col-lg-4">
      <div class="form-group has-float-label">
        <input [(ngModel)]="resource.PONUMBER" class="form-control" id="" type="text"
          placeholder="PO Number" (keyup)="getListpoNumber()"/>
          <label for="">PO Number *</label>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group has-float-label">
          <select class="form-control" [(ngModel)]="resource.PO_LINE_ID" (ngModelChange)="resource.updated = true">
            <option>SELECT</option>
            @for (item of listPoNumber; track item) {
              <option value="{{item.PO_LINE_ID}}">{{item.DESCRIPTION}}</option>
            }
          </select>
          <label for="">PO Line *</label>
        </div>
      </div>
      <div class="col-lg-4">
      </div>
      <div class="col-lg-4">
        <div class="form-group has-float-label">
          <input [(ngModel)]="resource.START_DATE" type="date" class="form-control"
            placeholder="dd/mm/yyyy" id="start_date"/>
            <label for="">Start Date *</label>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group has-float-label">
            <input [(ngModel)]="resource.END_DATE" type="date" class="form-control"
              placeholder="dd/mm/yyyy" id="end_date"/>
              <label for="">End Date *</label>
            </div>
          </div>
          <div class="col-lg-12">
            SOW: {{ upload.fileName }}
            <input
              hidden
              type="file"
              #uploader2
              accept=".tiff,.jfit,.bmp,.gif,.svg,.png,.jpeg,.svgz,.jpg,.webp,.ico,.xbm,.dbi,.pjp,.apng,.tif,.pjpeg,.avif"
              (change)="handleFileInput($event)"
              />
              <button
                type="button"
                class="btn btn-secondary"
                (click)="uploader2.click()"
                >
                Upload/Update File
              </button>
            </div>
            <div class="col-lg-12">
              <div class="col-lg-4" style="float: right;">
                <button type="submit" class="btn btn-sm btn-block btn-danger claroredbg" (click)="saveSow()"><i class="fa fa-save"></i> Save</button>
              </div>
            </div>
          </div>
